import { StorageInspiration } from 'src/app/models/configurators-2d/tunnel/storage/storage-tunnel-dtos';
import { HBMConfigurationData } from './hbm-configuration-data';

export class StorageConfigurationData extends HBMConfigurationData {
  inspiration?: StorageInspiration;
  storageConfigurationId?: string;
}
